import { useCronLogs } from '@/modules/cron-logs/hooks/useCronLogs'
import { CronLogsTable } from '@/modules/cron-logs/components/CronLogsTable'

export function CronLogsListPage() {
  const {
    data,
    total,
    isLoading,
    error,
    filters,
    setPage,
    setLimit,
    setStatusFilter,
    clearFilters,
  } = useCronLogs()

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Historial de ejecuciones CRON</h1>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-sm text-red-700">
          {error}
        </div>
      )}

      <div className="bg-white border rounded-lg shadow-sm">
        <CronLogsTable
          data={data}
          total={total}
          page={filters.page}
          limit={filters.limit}
          onPageChange={setPage}
          onLimitChange={setLimit}
          isLoading={isLoading}
          filters={filters}
          onStatusFilter={setStatusFilter}
          onClearFilters={clearFilters}
        />
      </div>
    </div>
  )
}
